document.addEventListener("DOMContentLoaded", () => {
     const popup = document.querySelector("#promo-popup");

     if (!popup) return;

    // const openButtons = document.querySelectorAll(".js-open-promo-popup");

    

    // openButtons.forEach(button => {
    //     button.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         // popup.querySelector('.promo-popup__image img').src = button.dataset.image;
    //         // popup.querySelector('h2').textContent = button.dataset.title;
    //         // popup.querySelector('.compare').textContent = button.dataset.price;
    //         // popup.querySelector('.description').innerHTML = button.dataset.description;
    //         // popup.querySelector('.promo-popup__button').href = button.dataset.url;
    //         // popup.querySelector('.promo-popup__button').textContent = button.dataset.button;
    //         popup.classList.add("active");
    //         document.body.style.position = "fixed";
    //         document.body.style.width = "100%";
    //     });
    // });

    function closePopup() {
        popup.classList.remove("active");
        document.body.style.position = "";
        document.body.style.width = "";

    }

    popup.querySelector(".promo-popup__close")
        .addEventListener("click", closePopup);
    popup.querySelector(".a-promo-popup__close")
        .addEventListener("click", closePopup);

    popup.querySelector(".promo-popup__overlay")
        .addEventListener("click", closePopup);
});